import React from 'react';
import { motion } from 'framer-motion';
/**
 * SummaryShell — shared layout for all Session Summary modes (§20.6 G5).
 *
 * Provides the common visual grammar across Quick Recap, Celebrated and
 * Reflection: gradient base, max-width, padding and centered column. The
 * tonal shift signals *which* kind of ending without breaking the feeling
 * that the child is on the same screen.
 */
export type SummaryTone = 'quick' | 'celebrated' | 'reflection' | 'aborted';
const TONE_GRADIENTS: Record<SummaryTone, string> = {
  quick: 'from-slate-50 via-white to-indigo-50/40',
  celebrated: 'from-amber-50 via-white to-amber-50/40',
  reflection: 'from-amber-50/50 via-white to-orange-50/40',
  aborted: 'from-slate-50 via-white to-slate-50'
};
interface SummaryShellProps {
  tone: SummaryTone;
  children: React.ReactNode;
  className?: string;
  /** Optional element rendered absolutely in bottom-right (e.g. persistent → arrow during Moments). */
  cornerSlot?: React.ReactNode;
}
export function SummaryShell({
  tone,
  children,
  className = '',
  cornerSlot
}: SummaryShellProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.25
  }} className={`relative min-h-screen w-full bg-gradient-to-br ${TONE_GRADIENTS[tone]} ${className}`} data-id="element-9063">
      <div className="mx-auto flex min-h-screen w-full max-w-2xl flex-col items-center justify-center px-4 py-8 sm:px-6" data-id="element-9064">
        {children}
      </div>

      {cornerSlot && <div className="pointer-events-auto absolute bottom-6 right-6 z-10" data-id="element-9065">
          {cornerSlot}
        </div>}
    </motion.div>;
}